import developers from './developers.json';
export function getKeywords(window, keywords = {}) {
    var _a, _b, _c;
    const name = (_a = window.__gameData) === null || _a === void 0 ? void 0 : _a.name;
    const externalId = ((_b = window.__gameData) === null || _b === void 0 ? void 0 : _b.meta.alias) || ((_c = window.__gameData) === null || _c === void 0 ? void 0 : _c.meta.slug);
    const title = window.document.title;
    const developer = developers.find(d => d[0] === name) || 'Arkadium'; // Get developer
    return Object.assign(Object.assign({}, keywords), { externalId, // GameAlias or GameSlug
        title, // GameTitle
        developer });
}
